import noop from '@gaia/util/noop/action'
import submit from 'app/adminNotice/action/submit'

export default {
  deleteAccount: noop,
  serialUnknown: noop,
  submit,
}
